import { PlanLimitConfigs, BillingCycleConfig } from '../types.ts';

export const JIRA_DEFAULT_BILLING_CYCLE = 'MONTHLY';
export const JIRA_DEFAULT_UNIT_COUNT = 300;

export const JIRA_MIN_ENTERPRISE_USER_COUNT = 801;

export const jiraOfferingSkus = {
	free: 'jira-software-free',
	standard: 'jira-software-standard',
	premium: 'jira-software-premium',
	enterprise: 'jira-software-enterprise-sku',
} as const;

export const jiraOfferingSkusArray = Object.values(jiraOfferingSkus);

export const jiraPlanLimitConfigs: PlanLimitConfigs[] = [
	{
		planName: 'Free',
		offeringSku: jiraOfferingSkus.free,
		recommendationLimit: 0,
		signupLimit: 100_000,
	},
	{
		planName: 'Standard',
		offeringSku: jiraOfferingSkus.standard,
		recommendationLimit: 10,
		signupLimit: 100_000,
	},
	{
		planName: 'Premium',
		offeringSku: jiraOfferingSkus.premium,
		recommendationLimit: 250,
		signupLimit: 100_000,
	},
	{
		planName: 'Enterprise',
		offeringSku: jiraOfferingSkus.enterprise,
		recommendationLimit: 5000,
		signupLimit: 100_000,
		minUnitCount: JIRA_MIN_ENTERPRISE_USER_COUNT,
	},
];

export const jiraBillingCycleConfig: BillingCycleConfig = {
	monthly: true,
	annual: true,
};
